import request from './request';

// * 드라이브 탐색 관련
// 드라이브 조회 API
export const getDriveList = (userId, types = ['individual']) => {
  return request.get(`/portal/api/file-transfer/drive/${userId}?types=${JSON.stringify(types)}`);
};

// 디렉토리 조회 API
export const getDirectoryContents = (path) => {
  return request.get(`/transfer/directory/${encodeURIComponent(path)}`);
};

// * 업로드 관련
// 업로드 요청 API
export const requestUpload = (data) => {
  return request.post(`/transfer/upload`, data);
};

// 청크 업로드 API
export const uploadChunk = (data) => {
  return request.put(`/transfer/upload`, data);
};

// 업로드 완료 알림 API
export const completeUpload = (data) => {
  return request.post(`/transfer/upload/complete`, data);
};

// * 다운로드 관련
// 다운로드 요청 API
export const requestDownload = (data) => {
  return request.post(`/transfer/download`, data);
};

// 다운로드 상태 확인 API
export const checkDownloadStatus = (jobId) => {
  return request.get(`/transfer/download/${jobId}`);
};

// 파일 다운로드 URL 생성
export const getDownloadUrl = (jobId) => {
  return `/transfer/download?jobId=${jobId}`;
};
